export function ninCalculator() {
    const getNinReference = () => {
        const randomDivisibleBy4 = generateRandomDivisibleBy4();
        return manipulateNumber(randomDivisibleBy4);
    }

    function generateRandomDivisibleBy4() {
        let resultString = "";
        for (let i = 0; i < 17; i++) {
            const randomNumber = Math.floor(Math.random() * 6) + 4;
            resultString += randomNumber.toString();
        }

        return resultString
    }

    function getCenterThreeDigits(number) {
        const numString = number.toString();
        const startIndex = Math.floor((numString.length - 3) / 2);
        return numString.substr(startIndex, 3);
    }

    function manipulateNumber(number) {
        const centerThreeDigits = getCenterThreeDigits(number);
        const multipliedResult = parseInt(centerThreeDigits) * 3;
        const firstTwoDigits = Math.floor(multipliedResult / 100);
        const lastTwoDigits = multipliedResult % 100;

        return firstTwoDigits.toString() +
            number.toString() +
            lastTwoDigits.toString();
    }

    return {
        getNinReference
    }
}
